const DEFAULT_WORKBENCH_THEME = 'light';

export { DEFAULT_WORKBENCH_THEME as D };
